// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__3ros1","loading":"Button_loading__2nORI","primary":"Button_primary__I_9I9","secondary":"Button_secondary__1gv5E","transparent":"Button_transparent__2MRNf"};